<template>
  <div class="form">
    <div class="left-col">
      <div class="input-block">
        <label for="community-name">{{ $t('community.communityForm.name') }}</label>
        <input data-cy="community-name" id="community-name"
               name="name"
               v-model="community.name"
               class="input"
               maxlength="64"
               v-validate="'required'"
        />
        <div class="under-field-container">
          <div v-if="errors.items.filter(item => item.field === 'name').length > 0"
               class="validate-message"
          >
            {{ $t('community.communityForm.validationRequiredName') }}
          </div>
          <span v-if="community.name.length > 0">{{ community.name.length }}/64</span>
        </div>
      </div>
      <div class="input-block">
        <label for="short-description">{{ $t('community.communityForm.description') }}</label>
        <textarea id="short-description"
                  data-cy="community-desc"
                  v-model="community.description"
                  name="description"
                  class="input"
                  maxlength="256"
                  v-validate="'required'"
        />
        <div class="under-field-container">
          <div v-if="errors.items.filter(item => item.field === 'description').length > 0"
               class="validate-message"
          >
            {{ $t('community.communityForm.validationRequiredDescription') }}
          </div>
          <span v-if="community.description.length > 0">{{ community.description.length }}/256</span>
        </div>
      </div>
      <div v-if="editType">
        <div class="container public">
          <div class="radio">
            <label for="visibility-public">{{ $t('community.communityForm.public') }}
              <input id="visibility-public"
                     type="radio"
                     value="public"
                     v-model="community.type"
              />
              <span class="checkmark" />
            </label>
          </div>
          <span class="help-info left">{{ $t('community.communityForm.publicInfo') }}</span>
        </div>
        <div class="container private">
          <div class="radio">
            <label for="visibility-private">{{ $t('community.communityForm.private') }}
              <input id="visibility-private"
                     type="radio"
                     value="private"
                     v-model="community.type"
              />
              <span class="checkmark" />
            </label>
          </div>
          <span class="help-info left">{{ $t('community.communityForm.privateInfo') }}</span>
        </div>
      </div>
      <div v-else class="blank-container" />
    </div>
    <div class="right-col">
      <community-image-select class="image-select"
                              :id-image="community.idImage"
                              @changeImage="onChangeImage"
                              @removeImage="onRemoveImage"
      />
      <div class="checkbox">
        <input type="checkbox"
               id="checkbox"
               v-model="community.isBroadcast"
        />
        <label for="checkbox">{{ $t('community.communityForm.broadcast') }}</label>
      </div>
      <span class="help-info right">{{ $t('community.communityForm.broadcastInfo') }}</span>
    </div>
  </div>
</template>

<script>
import CommunityImageSelect from './CommunityImageSelect'

export default {
  name: 'CommunityForm',
  components: { CommunityImageSelect },
  props: {
    community: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    image: {
      type: String,
      required: false,
      default: ''
    },
    editType: {
      type: Boolean
    }
  },
  methods: {
    async isFormValid() {
      const result = await this.$validator.validateAll()
      return !!result
    },
    onChangeImage(image) {
      this.$emit('changeImage', image.data)
    },
    onRemoveImage() {
      this.$emit('changeImage', '')
    },
    isValidImage() {
      // uploaded image should be less than 10 Mo
      if (typeof this.image === 'string') {
        const encodedImage = Buffer.from(this.image, 'base64')
        return encodedImage.length > 0 && encodedImage.length <= 10000000
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.modal-content {
  width: 912px;

  @media (max-width: $header-change) {
      width: 100vw;
  }

  .form {
    display: flex;
    align-items: stretch;
    height: 455px;

    @media (max-width: $header-change) {
        width: 100vw;
        height: calc(100vh - 150px) !important;
      flex-wrap: wrap;
      overflow-y: scroll;
    }

    .help-info {
      font-size: 13px;
      text-align: left;

      &.left {
        margin-left: 30px;
      }

      &.right {
        margin-left: 20px;
      }
    }

    .left-col {
      display: flex;
      flex-direction: column;
      width: 426px;
      align-items: flex-start;
      padding: 24px 24px 0 24px;

      @media (max-width: $header-change) {
            width: 100vw;
      }

      .input-block {
        margin-bottom: 31px;
        font-size: 13px;
        letter-spacing: 0;
        line-height: 19px;
        color: $black-color;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .under-field-container {
          height: 1.2rem;

          .validate-message {
            color: $cerise-color;
            font-weight: bold;
            display: inline;
          }

          span {
            display: inline;
          }
        }

        .input {
          background: #FFFFFF;
          border: 1px solid #D8D8D8;
          border-radius: 3px;
          min-height: 31px;

          &.error {
            border: 1px solid $cerise-color;
          }
        }

        input {
          padding: 0 10px;
          width: 404px;

          @media (max-width: $header-change) {
              width: calc(100vw - 100px);
          }
        }

        textarea {
          height: 55px;
          max-width: 404px;
          width: 404px;
          padding: 10px 10px;
          font-family: OpenSans-Regular, sans-serif;
          font-size: 13px;
          resize: none;

          @media (max-width: $header-change) {
              width: calc(100vw - 100px);
              max-width: none;
          }
        }
      }

      .blank-container {
        height: 146px;
      }
    }

    .right-col {
      margin-left: 1.5rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media (max-width: $header-change) {
          width: 100vw;
          padding-bottom: 10px;
      }

      .checkbox {
        font-size: 15px;
        display: flex;
        align-items: flex-end;

        input:hover, label:hover {
          color: $primary-color;
          cursor: pointer;
        }
      }

      .image-select {
        margin: 1.5rem 0;
        width: 396px;
        height: 223px;

        @media (max-width: $header-change) {
            width: 90% !important;
        }
      }
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;

  &.public {
    margin-bottom: 20px;
  }

  &.private {
    margin-bottom: 5px;
  }

  /* Customize the label (the container) */
  .radio {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    font-size: 15px;
    line-height: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    &:hover {
      .checkmark {
        border-color: $primary-color;
      }

      label {
        color: $primary-color;
        cursor: pointer;
      }
    }

    /* Hide the browser's default radio button */
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
      /* When the radio button is checked, add a blue background */
      &:checked ~ .checkmark {
        background-color: white;
        border: 5px solid $primary-color;
        border-radius: 50%;
        width: 10px;
        height: 10px;
      }

      /* Show the indicator when checked */
      & ~ .checkmark:after {
        display: block;
      }
    }

    .checkmark {
      position: absolute;
      top: 1px;
      left: 1px;
      background-color: white;
      border: 1px solid lightgray;
      border-radius: 50%;
      width: 18px;
      height: 18px;
    }
  }
}

.left-col {
  display: flex;
  flex-direction: column;
  width: 426px;
  align-items: flex-start;
  padding: 24px;

  .input-block {
    margin-bottom: 31px;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 19px;
    color: $black-color;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .under-field-container {
      height: 1.2rem;

      .validate-message {
        color: $cerise-color;
        font-weight: bold;
        display: inline;
      }

      span {
        display: inline;
      }
    }

    .input {
      background: #FFFFFF;
      border: 1px solid #D8D8D8;
      border-radius: 3px;
      min-height: 31px;

      &.error {
        border: 1px solid $cerise-color;
      }
    }

    input {
      padding: 0 10px;
      width: 404px;
    }

    textarea {
      height: 55px;
      max-width: 404px;
      width: 404px;
      padding: 10px 10px;
      font-family: OpenSans-Regular, sans-serif;
      font-size: 13px;
      resize: none;
    }
  }
}
</style>
